import React from "react";
import getConfig from "next/config";

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
const apiKey =
    serverRuntimeConfig?.BUGSNAG_API_KEY ||
    publicRuntimeConfig?.BUGSNAG_API_KEY;

let BugsnagExport;

if (apiKey) {
    const Bugsnag = require("@bugsnag/js").default;
    const BugsnagPluginReact = require("@bugsnag/plugin-react").default;
    Bugsnag.start({
        apiKey,
        plugins: [new BugsnagPluginReact(React)],
    });
    BugsnagExport = Bugsnag;
} else {
    BugsnagExport = {
        getPlugin: () => {
            const PassThrough = ({ children }) => children;
            return PassThrough;
        },
        notify: () => {},
    };
}

export default BugsnagExport;
